<pm-widget-base-wrapper [isLoading]="isLoading" [name]="name">
  <ng-template
    pmWidgetTitle
    infoTooltipText="{{
      'RESULT.INSIGHTS.WIDGETS.YEAR_BY_YEAR_COMPARISON.TOOLTIP' | translate
    }}"
  >
    {{ 'RESULT.INSIGHTS.WIDGETS.YEAR_BY_YEAR_COMPARISON.TITLE' | translate }}
  </ng-template>
  <ng-template pmWidgetHeader>
    <pm-form-field label="RESULT.INSIGHTS.GENERAL.SELECT_FILTER">
      <pm-form-input-select
        [formControl]="selectedFilterFormControl"
        [data]="filtersGroupOptions()"
      />
    </pm-form-field>

    <pm-form-field label="RESULT.INSIGHTS.GENERAL.SELECT_DATASET">
      <pm-form-input-select
        [allowSearching]="true"
        [allowUnselect]="false"
        [formControl]="selectedValueFormControl"
        [data]="filtersValuesOptions()"
      />
    </pm-form-field>
  </ng-template>
  <ng-template pmWidgetContent>
    @if (datasetHasValidDataPoints) {
      @if (this.isError) {
        <div class="flex justify-center items-center h-full text-center p-4">
          <pm-h3>
            {{ 'RESULT.INSIGHTS.GENERAL.TECHNICAL_ERROR' | translate }}
          </pm-h3>
        </div>
      } @else {
        <highcharts-chart
          id="year-to-date-trend-chart"
          [oneToOne]="true"
          [options]="chartOptions()"
          class="!w-full !h-full !block"
        >
        </highcharts-chart>
      }
    } @else {
      <div class="flex justify-center items-center h-full text-center p-4">
        <pm-h3>
          {{
            'RESULT.INSIGHTS.WIDGETS.YEAR_BY_YEAR_COMPARISON.DATASET_INVALID'
              | translate
          }}
        </pm-h3>
      </div>
    }
  </ng-template>
  <ng-template pmWidgetActions>
    @if (isDialogInstance) {
      <pm-button
        variant="subdued"
        [pmTooltip]="'RESULT.INSIGHTS.BUTTONS.EXIT_FULL_SCREEN_TOOLTIP'"
        (handleClick)="exitFullScreen()"
        [icon]="scanIcon"
      />
    } @else {
      <pm-button
        variant="subdued"
        [pmTooltip]="'RESULT.INSIGHTS.BUTTONS.FULL_SCREEN_TOOLTIP'"
        [icon]="scanIcon"
        (handleClick)="
          showFullScreen(YearlyComparisonWidgetComponent, {
            resolution: this.resolution,
            targetUnit: this.targetUnit,
            filterColumn: this.selectedFilterFormControl.getRawValue().column,
            filterOptions: this.selectedValueFormControl.getRawValue(),
          })
        "
      />
    }
  </ng-template>
</pm-widget-base-wrapper>
